import { Injectable } from '@angular/core';

// Removes what the previous video design left registered on devices.
//
// Saved video used to play through a hand-written service worker (assets/offline-video-sw.js,
// scope /assets/offline-video/) and an iframed player page. Both are gone: a saved video is now
// a plain file played through URL.createObjectURL (offline-video-files.ts). But a service
// worker registration outlives the script it came from, so every device that ever registered
// it keeps it, plus its cached player page, until something unregisters it. That is this.
//
// Only touches the old video worker's scope. Angular's ngsw (scope "/") is never affected.
@Injectable({
  providedIn: 'root',
})
export class OfflineVideoPlaybackService {
  private static readonly LEGACY_SCOPE_SUFFIX = '/assets/offline-video/';
  private static readonly LEGACY_CACHE_PREFIX = 'impata-offline-video-shell-';

  // Fire-and-forget, never throws.
  async removeLegacyVideoWorker(): Promise<void> {
    try {
      if (navigator.serviceWorker?.getRegistrations) {
        const registrations = await navigator.serviceWorker.getRegistrations();
        for (const reg of registrations) {
          if (reg.scope.endsWith(OfflineVideoPlaybackService.LEGACY_SCOPE_SUFFIX)) {
            await reg.unregister();
          }
        }
      }
      if (typeof caches !== 'undefined') {
        const names = await caches.keys();
        await Promise.all(names.filter((n) => n.startsWith(OfflineVideoPlaybackService.LEGACY_CACHE_PREFIX)).map((n) => caches.delete(n)));
      }
    } catch (err) {
      console.error('[offline] could not remove the old video service worker', err);
    }
  }
}
